/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonPhoneRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonPhoneRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/ResponsiblePersonPhoneRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Responsible Person's Phone Number"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/ResponsiblePersonPhone")}
 isSelected={flow.has("/App/Form/Data/ProvideData/ResponsiblePersonPhone")}
 text={text}
/>
{children}
</React.Fragment>)
}